export const EVisitorStatus = {
  PRIJAVLJEN: 'PRIJAVLJEN',
  ODJAVLJEN: 'ODJAVLJEN',
  NEPRIJAVLJEN: 'NEPRIJAVLJEN',
};

export const onlyActiveReservations = {
  'EqualsTo[status]': ['30', '40', '41', '42', '45', '50', '51', '52', '46', '57'],
};
